export default "__VITE_ASSET__17d3e59e__"